import React from 'react';

const Footer = () => {
    return (
        <div>
             <p style={{textAlign: 'center', fontSize:"18px", fontWeight:"500", fontFamily:"sans-serif",userSelect:"none"}}  className="mb-2">Copyright © {(new Date()).getFullYear()} Osman Faruk</p>
        </div>
    );
};

export default Footer;